import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import './PdfViewer.css';

const PdfViewer = () => {
  const { filename } = useParams();
  const navigate = useNavigate();

  const [pdfUrl, setPdfUrl] = useState('');
  const [decodedFilename, setDecodedFilename] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!filename) {
      setError('Invalid file name');
      setLoading(false);
      return;
    }

    try {
      // Decode filename from URL
      const decoded = decodeURIComponent(filename);
      setDecodedFilename(decoded);

      // Re-encode safely for browser request
      const safeFilename = encodeURIComponent(decoded);
      const url = `/documents/${safeFilename}`;

      setPdfUrl(url);
      setLoading(true);
      setError('');
    } catch (err) {
      console.error(err);
      setError('Failed to process file name');
      setLoading(false);
    }
  }, [filename]);

  const handleIframeLoad = () => {
    setLoading(false);
  };

  const handleDownload = () => {
    if (!pdfUrl) return;

    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = decodedFilename || 'document.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleOpenInNewTab = () => {
    if (pdfUrl) {
      window.open(pdfUrl, '_blank');
    }
  };

  return (
    <div className="pdf-viewer-page">
      {/* Navbar */}
      <nav className="pdf-viewer-navbar">
        <div className="navbar-content">
          <div className="navbar-left">
            <Link to="/" className="navbar-logo">
              CBC Centre
            </Link>
            <div className="file-info">
              <span className="file-name">{decodedFilename}</span>
            </div>
          </div>

          <div className="navbar-right">
            <button className="nav-back-btn" onClick={() => navigate(-1)}>
              ← Back
            </button>
            <button
              className="nav-download-btn"
              onClick={handleDownload}
              disabled={!pdfUrl}
            >
              ⬇ Download
            </button>
          </div>
        </div>
      </nav>

      {/* Main Viewer */}
      <div className="pdf-viewer-main">
        {error && (
          <div className="pdf-error">
            <h3>Error Loading PDF</h3>
            <p>{error}</p>
            <button onClick={() => navigate(-1)}>Go Back</button>
          </div>
        )}

        {!error && (
          <div className="pdf-iframe-container">
            {loading && (
              <div className="pdf-loading">
                <div className="loading-spinner"></div>
                <p>Loading PDF document…</p>
                <button className="loading-open-btn" onClick={handleOpenInNewTab}>
                  Open in new tab
                </button>
              </div>
            )}

            <iframe
              src={`${pdfUrl}#view=FitH&toolbar=1`}
              title={`PDF: ${decodedFilename}`}
              className="pdf-iframe"
              onLoad={handleIframeLoad}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PdfViewer;
